import client from '../api/client.js'

/**
 * Strip empty/null/undefined values from query params so backend
 * doesn't receive spurious filter noise.
 */
const normalizeAuditParams = (params = {}) => {
  return Object.entries(params).reduce((acc, [key, value]) => {
    if (value === '' || value === null || value === undefined) return acc
    acc[key] = value
    return acc
  }, {})
}

/**
 * GET /admin/audit-logs   (superadmin only — returns 403 for all other roles)
 *
 * Supported params (all optional):
 *   page, page_size, user_id, lottery_id, action, start_date, end_date
 *
 * @param {object} params   - filter / pagination params
 * @param {object} options  - { signal: AbortSignal }
 * @returns {Promise<object>} backend response data
 */
export const fetchAuditLogsRequest = async (params = {}, options = {}) => {
  const response = await client.get('/admin/audit-logs', {
    params: normalizeAuditParams(params),
    ...(options?.signal ? { signal: options.signal } : {}),
  })
  return response?.data
}

